import { classNames } from "primereact/utils";
import styles from "./RowMessage.module.scss";

interface IRowMessageProps {
  className?: string;
  message: string;
  type: "error" | "warning";
}

export const RowMessage = ({ className, message, type }: IRowMessageProps) => {
  return (
    <div
      className={classNames(styles.root, className, {
        [styles.root_error]: type === "error",
        [styles.root_warning]: type === "warning",
      })}
    >
      {message}
    </div>
  );
};
